import { render } from "./WCPromoRibbon.vue?vue&type=template&id=45cefd2a&scoped=true"
import script from "./WCPromoRibbon.vue?vue&type=script&lang=js"
export * from "./WCPromoRibbon.vue?vue&type=script&lang=js"

import "./WCPromoRibbon.vue?vue&type=style&index=0&id=45cefd2a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45cefd2a"]])

export default __exports__